import { render, staticRenderFns } from "./LbaFulltextSearchContentTab.vue?vue&type=template&id=b78b33dc"
import script from "./LbaFulltextSearchContentTab.vue?vue&type=script&lang=js"
export * from "./LbaFulltextSearchContentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports